module.exports = __webpack_public_path__ + "themes/fq/img/frame@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/img/frame@2x.png
// module id = 62
// module chunks = d-game